import { ROUTE } from "../../../routes";
export const needHelp = async (action, _datastore, { navigate, instrumentTrack }) => {
    instrumentTrack('CONTACT_US_BUTTON_CLICKED');
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const goBack = async (action, _datastore, { goBack, navigateWithClear }) => {
    await goBack();
};
